import Vue from 'vue'
import Vuex from 'vuex'
import createPersist from 'vuex-localstorage'

Vue.use(Vuex)

// IMPORT MODULE
import auth from './auth'
import cart from './cart'

export default new Vuex.Store({
  strict: false,
  state: {
    url: 'https://tokomanamana.com/files/images/',
    urlTmm: 'https://tokomanamana.com/',
    alert: {
      status: false,
      color: '',
      message: '',
    },
    durationOTP: 0,
    notifOrder: 0,
  },
  mutations: {
    SET_ALERT(state, payload) {
      state.alert = payload
    },
    CLOSE_ALERT(state) {
      state.alert = {
        status: false,
        color: '',
        message: '',
      }
    },
    SET_DURATION_OTP(state, payload) {
      state.durationOTP = payload
    },
    SET_NOTIF_ORDER(state, payload) {
      state.notifOrder = payload
    }
  },
  getters: {
    GET_ALERT(state) {
      return state.alert
    },
    GET_DURATION_OTP(state) {
      return state.durationOTP
    },
    GET_NOTIF_ORDER(state) {
      return state.notifOrder
    }
  },
  actions: {},
  modules: {
    auth,
    cart,
  },
  plugins: [
    createPersist({
      namespace: 'auth',
      initialState: {},
      // ONE WEEK
      expires: 7 * 24 * 60 * 1e3,
      modules: {
        auth
      }
    })
  ]
})